module.exports = __webpack_public_path__ + "static/media/cadillac-go-drive.b5f9687a.png";